import imageMethods from './methods/imageMethods'

export default {
  ...imageMethods,

  replaceVars: (template, data) => {
    if (!data || !template) {
      return ''
    }
    const pattern = /\{(.*?)\}/g
    return template.replace(pattern, (match, token) => data[token])
  }
}
